import BaseTable from '@/components/bases/BaseTable';
import utils from '@/utils';
import { TableColumnsType } from 'antd';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export interface IMemberTableProps {
  data: any;
}

export default function MemberTable(props: IMemberTableProps): JSX.Element {
  const navigate = useNavigate();
  const data = props.data;
  const columns: TableColumnsType<any> = [
    { width: '20%' },
    {
      width: '20%',
      title: 'Tên thành viên',
      dataIndex: 'username',
      key: 'username',
    },
    { width: '20%', title: 'Số điện thoại', dataIndex: 'phone', key: 'phone' },
    {
      width: '20%',
      title: 'Ngày sinh',
      dataIndex: 'birthday',
      key: 'birthday',
      render(value) {
        return utils.safeFormat(value);
      },
    },
    { width: '20%' },
  ];

  return (
    <div className="px-4 pb-4">
      <BaseTable
        className="[&_.ant-table]:shadow-none"
        size="small"
        columns={columns}
        onRow={(record) => ({
          onClick: () => {
            navigate(`/phr/${record?._id}`);
          },
        })}
        dataSource={data}
        scroll={{ y: 150 }}
        pagination={false}
      />
    </div>
  );
}
